const meta = {
  'user-accounts': 'User accounts',
  'personal-access-tokens': 'Personal access tokens',
  'service-accounts': 'Service accounts',
  teams: 'Teams',
  okta: 'Okta user synchronization',
};

export default meta;
